import { render, staticRenderFns } from "./MzError.vue?vue&type=template&id=315cfc6c&"
import script from "./MzError.vue?vue&type=script&lang=js&"
export * from "./MzError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports